import { engineComponent, NumberUtils, KeyboardUtils } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlContainerElement } from "./HtmlContainerElement";
import { HtmlController } from "../HtmlController";
import { AppContext } from "../../../Common/AppContext";
import { BetManager } from "../../Managers/BetManager";
import { GameData } from "../../Channels/Common/Datas/GameData";
import { DataManager } from "../../Managers/DataManager";
import { PlayList } from "../../Components/Sounds/PlayList";
import { Languages } from "../../Utils/Languages";
import { ModuleManager } from "../../Managers/ModuleManager";
import { BaseActions } from "../../Channels/Common/Actions/BaseActions";
import { HtmlButtonElement } from "./HtmlButtonElement";
import { BonusActions } from "../../Channels/Common/Actions/BonusActions";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlAutoplayDialogContainerElement extends HtmlContainerElement {
    private _autoplayDialogCounts: Array<HTMLElement> = [];
    private _autoplayDialogLossLimit: Array<HTMLElement> = [];
    private _autoplayDialogWinLimit: Array<HTMLElement> = [];
    private _autoplayDialogSkipWin: Array<HTMLElement> = [];

    private _lossValueElement: HTMLElement;
    private _winValueElement: HTMLElement;

    private _button: HTMLElement;

    private _count: string = "∞";
    private _loss: string = "∞";
    private _win: string = "∞";

    constructor() {
        super();
    }
    create(node: Element): void {
        super.create(node);

        this.createCounts();
        this.createLossLimits();
        this.createWinLimits();
        this.createSkipWinButtons();

        this._lossValueElement = document.getElementById("autoplayDialogLossLimitValue");
        this._winValueElement = document.getElementById("autoplayDialogWinLimitValue");
        this._button = document.getElementById("autoplayDialogButton");
        this._button.onclick = this.runAutoplay.bind(this);

        this.reset();
    }

    private createCounts(): void {
        if (HtmlController.ContainerElementsById["autoplayDialogCounts"] != null) {
            let element: HtmlContainerElement = HtmlController.ContainerElementsById["autoplayDialogCounts"];
            if (element != null && element.instance != null) {
                if (
                    AppContext.gameConfiguration.AutoplayCounts != null &&
                    AppContext.gameConfiguration.AutoplayCounts.length > 0
                ) {
                    for (let i: number = 0; i < AppContext.gameConfiguration.AutoplayCounts.length; i++) {
                        let item: HTMLDivElement = <HTMLDivElement>document.createElement("div");
                        let itemValue: HTMLDivElement = <HTMLDivElement>document.createElement("span");
                        item.classList.add("settingItem");
                        itemValue.classList.add("settingValue");
                        if (AppContext.gameConfiguration.AutoplayCounts[i] == -1) {
                            itemValue.innerText = "∞";
                            item.setAttribute("Val", "∞");
                        } else {
                            itemValue.innerText = AppContext.gameConfiguration.AutoplayCounts[i] + "";
                            item.setAttribute("Val", AppContext.gameConfiguration.AutoplayCounts[i] + "");
                        }
                        item.dataset["test"] = `AUTOPLAY_CNT_${i + 1}`;
                        item.appendChild(itemValue);
                        item.onclick = this.onCountClick.bind(this);
                        element.instance.appendChild(item);
                        this._autoplayDialogCounts.push(item);
                    }
                }
            }
        }
    }

    private createLossLimits(): void {
        if (HtmlController.ContainerElementsById["autoplayDialogLossLimit"] != null) {
            let element: HtmlContainerElement = HtmlController.ContainerElementsById["autoplayDialogLossLimit"];
            if (element != null && element.instance != null) {
                if (
                    AppContext.gameConfiguration.AutoplayLossLimit != null &&
                    AppContext.gameConfiguration.AutoplayLossLimit.length > 0
                ) {
                    for (let i: number = 0; i < AppContext.gameConfiguration.AutoplayLossLimit.length; i++) {
                        let item: HTMLDivElement = <HTMLDivElement>document.createElement("div");
                        let itemValue: HTMLDivElement = <HTMLDivElement>document.createElement("span");
                        item.classList.add("settingItem");
                        itemValue.classList.add("settingValue");
                        if (AppContext.gameConfiguration.AutoplayLossLimit[i] == -1) {
                            itemValue.innerText = "∞";
                            item.setAttribute("Val", "∞");
                        } else {
                            itemValue.innerText = "x" + AppContext.gameConfiguration.AutoplayLossLimit[i] + "";
                            item.setAttribute("Val", AppContext.gameConfiguration.AutoplayLossLimit[i] + "");
                        }
                        item.dataset["test"] = `AUTOPLAY_LOSS_CNT_${i + 1}`;
                        item.appendChild(itemValue);
                        item.onclick = this.onLossClick.bind(this);
                        element.instance.appendChild(item);
                        this._autoplayDialogLossLimit.push(item);
                    }
                }
            }
        }
    }

    private createWinLimits(): void {
        if (HtmlController.ContainerElementsById["autoplayDialogWinLimit"] != null) {
            let element: HtmlContainerElement = HtmlController.ContainerElementsById["autoplayDialogWinLimit"];
            if (element != null && element.instance != null) {
                if (
                    AppContext.gameConfiguration.AutoplaySingleWinLimit != null &&
                    AppContext.gameConfiguration.AutoplaySingleWinLimit.length > 0
                ) {
                    for (let i: number = 0; i < AppContext.gameConfiguration.AutoplaySingleWinLimit.length; i++) {
                        let item: HTMLDivElement = <HTMLDivElement>document.createElement("div");
                        let itemValue: HTMLDivElement = <HTMLDivElement>document.createElement("span");
                        item.classList.add("settingItem");
                        itemValue.classList.add("settingValue");
                        if (AppContext.gameConfiguration.AutoplaySingleWinLimit[i] == -1) {
                            itemValue.innerText = "∞";
                            item.setAttribute("Val", "∞");
                        } else {
                            itemValue.innerText = "x" + AppContext.gameConfiguration.AutoplaySingleWinLimit[i] + "";
                            item.setAttribute("Val", AppContext.gameConfiguration.AutoplaySingleWinLimit[i] + "");
                        }
                        item.dataset["test"] = `AUTOPLAY_WIN_CNT_${i + 1}`;
                        item.appendChild(itemValue);
                        item.onclick = this.onWinClick.bind(this);
                        element.instance.appendChild(item);
                        this._autoplayDialogWinLimit.push(item);
                    }
                }
            }
        }
    }

    private createSkipWinButtons(): void {
        if (HtmlController.ContainerElementsById["autoplaySkipWinOption"] != null) {
            let element: HtmlContainerElement = HtmlController.ContainerElementsById["autoplaySkipWinOption"];
            if (element != null && element.instance != null) {
                if (AppContext.gameConfiguration.AutoplaySkipWinAnimationsEnabled) {
                    KeyboardUtils.bindKeyRelease("space", this.handleSkipWinSpaceBar);

                    for (let i = 0; i < 2; i++) {
                        let item: HTMLDivElement = <HTMLDivElement>document.createElement("div");
                        let itemValue: HTMLDivElement = <HTMLDivElement>document.createElement("span");
                        item.classList.add("settingItem");
                        itemValue.classList.add("settingValue");
                        itemValue.innerText = Languages.getRid(i == 0 ? "YES" : "NO");
                        item.setAttribute("Val", i == 0 ? "true" : "false");
                        item.appendChild(itemValue);
                        item.onclick = this.onSkipWinClick.bind(this);
                        element.instance.appendChild(item);
                        this._autoplayDialogSkipWin.push(item);
                    }
                } else {
                    if (HtmlController.ContainerElementsById["autoplaySkipWinOption"] != null) {
                        HtmlController.ContainerElementsById["autoplaySkipWinOption"].instance.style.display = "none";
                    }
                    if (HtmlController.ContainerElementsById["autoplayDialogSkipWinOptionView"] != null) {
                        HtmlController.ContainerElementsById["autoplayDialogSkipWinOptionView"].instance.style.display =
                            "none";
                    }
                }
            }
        }
    }

    private handleSkipWinSpaceBar(): void {
        if (HtmlController.ActionElements[BaseActions.ActionSkipWin] != null) {
            let skipWinBtn = <HtmlButtonElement>HtmlController.ActionElements[BaseActions.ActionSkipWin][0];
            if (skipWinBtn != null && !skipWinBtn.instance.classList.contains("_disabled")) {
                ModuleManager.dispatchAction(BaseActions.ActionSkipWin);
            }

            let fsSkipWinBtn = <HtmlButtonElement>HtmlController.ActionElements[BonusActions.ActionSkipWin][0];
            if (fsSkipWinBtn != null && !fsSkipWinBtn.instance.classList.contains("_disabled")) {
                ModuleManager.dispatchAction(BonusActions.ActionSkipWin);
            }
        }
    }

    reset(): void {
        this.resetCounts();
        this.resetLossLimits();
        this.resetWinLimits();
        this.enableCounts();
        this.resetSkipWin();
        if (this._lossValueElement != null) {
            this._lossValueElement.innerText = "";
        }
        if (this._winValueElement != null) {
            this._winValueElement.innerText = "";
        }
        if (this._button != null && !this._button.classList.contains("_disabled")) {
            this._button.classList.add("_disabled");
        }
        this._count = "∞";
        this._loss = "∞";
        this._win = "∞";

        DataManager.AutoplayCount = "∞";
        DataManager.AutoplayLossLimit = "∞";
        DataManager.AutoplayWinLimit = "∞";
    }

    private resetCounts(): void {
        if (this._autoplayDialogCounts != null && this._autoplayDialogCounts.length > 0) {
            for (let i: number = 0; i < this._autoplayDialogCounts.length; i++) {
                if (this._autoplayDialogCounts[i].classList.contains("_active")) {
                    this._autoplayDialogCounts[i].classList.remove("_active");
                }
                if (!this._autoplayDialogCounts[i].classList.contains("_disabled")) {
                    this._autoplayDialogCounts[i].classList.add("_disabled");
                }
            }
        }
    }

    private resetLossLimits(): void {
        if (this._autoplayDialogLossLimit != null && this._autoplayDialogLossLimit.length > 0) {
            for (let i: number = 0; i < this._autoplayDialogLossLimit.length; i++) {
                if (this._autoplayDialogLossLimit[i].classList.contains("_active")) {
                    this._autoplayDialogLossLimit[i].classList.remove("_active");
                }
                if (!this._autoplayDialogLossLimit[i].classList.contains("_disabled")) {
                    this._autoplayDialogLossLimit[i].classList.add("_disabled");
                }
            }
        }
    }

    private resetSkipWin(): void {
        DataManager.AutoplaySkipWinAnimationsEnabled = false;

        for (let i = 0; i < this._autoplayDialogSkipWin.length; i++) {
            let item = this._autoplayDialogSkipWin[i];
            item.classList.remove("_active");

            if (item.hasAttribute("Val")) {
                if (item.getAttribute("Val") == "false") {
                    item.classList.add("_active");
                }
            }
        }
    }

    private resetWinLimits(): void {
        if (this._autoplayDialogWinLimit != null && this._autoplayDialogWinLimit.length > 0) {
            for (let i: number = 0; i < this._autoplayDialogWinLimit.length; i++) {
                if (this._autoplayDialogWinLimit[i].classList.contains("_active")) {
                    this._autoplayDialogWinLimit[i].classList.remove("_active");
                }
                if (!this._autoplayDialogWinLimit[i].classList.contains("_disabled")) {
                    this._autoplayDialogWinLimit[i].classList.add("_disabled");
                }
            }
        }
    }

    private enableCounts(): void {
        if (this._autoplayDialogCounts != null && this._autoplayDialogCounts.length > 0) {
            for (let i: number = 0; i < this._autoplayDialogCounts.length; i++) {
                if (this._autoplayDialogCounts[i].classList.contains("_disabled")) {
                    this._autoplayDialogCounts[i].classList.remove("_disabled");
                }
            }
        }
    }

    private enableLossLimits(): void {
        if (this._autoplayDialogLossLimit != null && this._autoplayDialogLossLimit.length > 0) {
            for (let i: number = 0; i < this._autoplayDialogLossLimit.length; i++) {
                if (this._autoplayDialogLossLimit[i].classList.contains("_disabled")) {
                    this._autoplayDialogLossLimit[i].classList.remove("_disabled");
                }
            }
        }
    }

    private enableWinLimits(removeNoLimit: boolean = false): void {
        let enabledNoLimit: boolean = true;
        let noLimit: HTMLElement;

        if (this._autoplayDialogWinLimit != null && this._autoplayDialogWinLimit.length > 0) {
            for (let i: number = 0; i < this._autoplayDialogWinLimit.length; i++) {
                if (this._autoplayDialogWinLimit[i].classList.contains("_active")) {
                    enabledNoLimit = false;
                }

                if (this._autoplayDialogWinLimit[i].getAttribute("Val") == "∞") {
                    noLimit = this._autoplayDialogWinLimit[i];
                }

                if (this._autoplayDialogWinLimit[i].classList.contains("_disabled")) {
                    this._autoplayDialogWinLimit[i].classList.remove("_disabled");
                }
            }
        }

        if (enabledNoLimit && !removeNoLimit) {
            if (noLimit != null) {
                if (!noLimit.classList.contains("_active")) {
                    noLimit.classList.add("_active");
                    if (this._winValueElement != null) {
                        this._winValueElement.innerText = "∞";
                    }
                }
            }
        }

        if (removeNoLimit) {
            if (noLimit != null) {
                if (noLimit.classList.contains("_active")) {
                    noLimit.classList.remove("_active");
                }
            }
        }
    }

    private onCountClick(e: any): void {
        if (
            e != null &&
            e.currentTarget != null &&
            e.currentTarget.hasAttribute("Val") &&
            !e.currentTarget.classList.contains("_disabled")
        ) {
            PlayList.play("SND_Click");
            let val: string = e.currentTarget.getAttribute("Val");
            this.resetCounts();
            this.enableCounts();
            if (!e.currentTarget.classList.contains("_active")) {
                e.currentTarget.classList.add("_active");
            }
            if (e.currentTarget.classList.contains("_disabled")) {
                e.currentTarget.classList.remove("_disabled");
            }
            this._count = val;
            this.enableLossLimits();
            if (document.getElementById("autoplayDialogLossLimitView") != null) {
                document.getElementById("autoplayDialogLossLimitView").scrollIntoView(true);

                if (AppContext.gameDefinition.ClientHostType === "Mobile") {
                    document.getElementById("screen").scrollTop = 0;
                    document.getElementById("root").scrollTop = 0;
                }
            }
        }
    }

    private onLossClick(e: any): void {
        if (
            e != null &&
            e.currentTarget != null &&
            e.currentTarget.hasAttribute("Val") &&
            !e.currentTarget.classList.contains("_disabled")
        ) {
            PlayList.play("SND_Click");
            let val: string = e.currentTarget.getAttribute("Val");
            if (this._lossValueElement != null) {
                if (val != "∞" && BetManager.Bet != null) {
                    let calculatedValue: string = NumberUtils.multiply(val, BetManager.Bet);
                    this._lossValueElement.innerText =
                        calculatedValue + " " + DataManager.getDataById(GameData.DataCurrency);
                } else {
                    this._lossValueElement.innerText = "∞";
                }
            }

            this.resetLossLimits();
            this.enableLossLimits();
            if (!e.currentTarget.classList.contains("_active")) {
                e.currentTarget.classList.add("_active");
            }
            if (e.currentTarget.classList.contains("_disabled")) {
                e.currentTarget.classList.remove("_disabled");
            }
            if (this._button != null && this._button.classList.contains("_disabled")) {
                this._button.classList.remove("_disabled");
            }
            this._loss = val;
            this.enableWinLimits();
            if (document.getElementById("autoplayDialogWinLimitView") != null) {
                document.getElementById("autoplayDialogWinLimitView").scrollIntoView(true);
            }

            if (AppContext.gameDefinition.ClientHostType === "Mobile") {
                document.getElementById("screen").scrollTop = 0;
                document.getElementById("root").scrollTop = 0;
            }
        }
    }

    private onWinClick(e: any): void {
        if (
            e != null &&
            e.currentTarget != null &&
            e.currentTarget.hasAttribute("Val") &&
            !e.currentTarget.classList.contains("_disabled")
        ) {
            PlayList.play("SND_Click");
            let val: string = e.currentTarget.getAttribute("Val");
            if (this._winValueElement != null) {
                if (val != "∞" && BetManager.Bet != null) {
                    let calculatedValue: string = NumberUtils.multiply(val, BetManager.Bet);
                    this._winValueElement.innerText =
                        calculatedValue + " " + DataManager.getDataById(GameData.DataCurrency);
                } else {
                    this._winValueElement.innerText = "∞";
                }
            }
            this.resetWinLimits();
            this.enableWinLimits(true);
            if (!e.currentTarget.classList.contains("_active")) {
                e.currentTarget.classList.add("_active");
            }
            if (e.currentTarget.classList.contains("_disabled")) {
                e.currentTarget.classList.remove("_disabled");
            }
            this._win = val;

            if (AppContext.gameConfiguration.AutoplaySkipWinAnimationsEnabled) {
                if (document.getElementById("autoplaySkipWinOption") != null) {
                    document.getElementById("autoplaySkipWinOption").scrollIntoView(true);
                }

                if (AppContext.gameDefinition.ClientHostType === "Mobile") {
                    document.getElementById("screen").scrollTop = 0;
                    document.getElementById("root").scrollTop = 0;
                }
            } else {
                if (AppContext.gameDefinition.ClientHostType === "Mobile") {
                    if (document.getElementById("autoplayDialogButton") != null) {
                        document.getElementById("autoplayDialogButton").scrollIntoView(true);
                        document.getElementById("screen").scrollTop = 0;
                        document.getElementById("root").scrollTop = 0;
                    }
                }
            }
        }
    }

    private onSkipWinClick(e: any): void {
        if (
            e != null &&
            e.currentTarget != null &&
            e.currentTarget.hasAttribute("Val") &&
            !e.currentTarget.classList.contains("_disabled")
        ) {
            PlayList.play("SND_Click");
            let val: string = e.currentTarget.getAttribute("Val");
            DataManager.AutoplaySkipWinAnimationsEnabled = val == "true";

            for (let i = 0; i < this._autoplayDialogSkipWin.length; i++) {
                let item = this._autoplayDialogSkipWin[i];
                item.classList.remove("_active");
            }

            e.currentTarget.classList.add("_active");

            if (AppContext.gameDefinition.ClientHostType === "Mobile") {
                if (document.getElementById("autoplayDialogButton") != null) {
                    document.getElementById("autoplayDialogButton").scrollIntoView(true);
                    document.getElementById("screen").scrollTop = 0;
                    document.getElementById("root").scrollTop = 0;
                }
            }
        }
    }

    private runAutoplay(e: any): void {
        if (e != null && e.currentTarget != null && !e.currentTarget.classList.contains("_disabled")) {
            if (document.getElementById("autoPlayDialogTop") != null) {
                document.getElementById("autoPlayDialogTop").scrollTop = 0;
            }
            if (this._count != null) {
                DataManager.AutoplayCount = this._count;
            }
            if (this._loss != null && BetManager.Bet != null) {
                if (this._loss == "∞") {
                    DataManager.AutoplayLossLimit = this._loss;
                } else {
                    DataManager.AutoplayLossLimit = NumberUtils.multiply(this._loss, BetManager.Bet);
                }
            }
            if (this._win != null && BetManager.Bet != null) {
                if (this._win == "∞") {
                    DataManager.AutoplayWinLimit = this._win;
                } else {
                    DataManager.AutoplayWinLimit = NumberUtils.multiply(this._win, BetManager.Bet);
                }
            }
            HtmlController.dispatchAction("AUTOPLAY");
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Elements/HtmlAutoplayDialogContainerElement.ts
 **/